import React from 'react';
import { Table, Tabs, Select, Icon, Spin } from 'antd';
import SideNav from './SideNav';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import Highcharts from 'react-highcharts';
import chartsConfig from '../common/chartsConfig';
import ExportUtil from '../../common/ExportUtil';

const { TabPane } = Tabs;
const { Option } = Select;

class ChartsViolation extends React.Component {
    state = {
        loading: false,
        params: {
            type: 'patient',
            statisticType: 'FirstStage',
        },
        data: [],
        panes: [],
        activeKey: '',
    }

    onChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            let { panes, activeKey } = this.state;
            panes.map(item => {
                if (item.key == activeKey ) {
                    item.content = this.getContent();
                } else {
                    item.content = null;
                }
            });
            this.setState({ panes });
        });
    }

    loadData = () => {
        const { params, isSite } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.statisticAgainst,
            data: { ...params },
            dateType: 'json',
            doneResult: (res => {
                if (isSite) {
                    this.setState({
                        subId: '',
                        subtitle: '',
                        loading: false,
                        data: res.data,
                        tableData: res.tableData,
                        siteData: res.investigationSites,
                    }, () => {
                        let { panes, activeKey } = this.state;
                        panes.map(item => {
                            if (item.key == activeKey ) {
                                item.content = this.getContent();
                            } else {
                                item.content = null;
                            }
                        });
                        this.setState({ panes });
                    });
                } else {
                    this.setState({
                        loading: false,
                        data: res.data,
                    });
                }
            })
        }
        $.sendRequest(options)
    }

    loadSecondData = (params) => {
        const { type } = this.state.params;
        const options = {
            method: 'POST',
            url: API_URL.summary.statisticAgainstById,
            data: {
                type,
                ...params
            },
            dateType: 'json',
            doneResult: (res => {
                this.setState({
                    data: res.data,
                    tableData: res.tableData,
                    subId: params.againstTypeId,
                    subtitle: params.againstTypeName,
                });
            })
        };
        $.sendRequest(options)
    }

    export = () => {
        const { params, pagination, subId, subtitle = '' } = this.state;
        let url, exportParams;
        if (subtitle == '') {
            url = API_URL.summary.exportAgainst;
            exportParams = { ...params };
        } else {
            url = API_URL.summary.exportAgainstById;
            exportParams = { ...params, againstTypeId: subId, againstTypeName: subtitle };
        }
        ExportUtil.export(exportParams, pagination, url);
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        if (key == 'type' && value == 'non_patient') {
            params.statisticType = '';
        } else if (key == 'type' && value == 'patient') {
            params.statisticType = 'FirstStage';
        }
        params[key] = value;
        this.setState({
            params,
            activeKey: '0'
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { tableData, params } = this.state;
        const { type, statisticType } = params;
        let width;
        if (type == 'patient') {
            if (statisticType == 'FirstStage') {
                width = 105;
            } else if (statisticType == 'SecondStage' || statisticType == 'LastStage') {
                width = 140;
            }
        }
        const columns = [{
            title: '方案违背分类',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 90
        }];
        tableData.map((item, index) => {
            columns.push({
                title: item.againstTypeName,
                dataIndex: `${item.againstTypeName}_${index}`,
                key: `${item.againstTypeName}_${index}`,
                width,
            })
        });
        return columns;
    }

    renderTotal = (text, record) => {
        const obj = {
            children: text,
            props: {},
        }
        if (record.index && (typeof record.index != 'number')) {
            obj.props.colSpan = 3;
        }
        return obj;
    }

    renderCommon = (text, record) => {
        const obj = {
            children: text,
            props: {},
        }
        if (record.index && (typeof record.index != 'number')) {
            obj.props.colSpan = 0;
        }
        return obj;
    }

    getSiteColumns = () => {
        const { tableData, siteData = [] } = this.state;
        const isFixed = tableData.length > 4;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: isFixed && 'left',
            width: isFixed && 85,
            render: this.renderTotal
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: isFixed && 'left',
            width: isFixed && 100,
            render: this.renderCommon
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            fixed: isFixed && 'left',
            width: isFixed && 120,
            render: this.renderCommon
        }];

        if (siteData.length > 0) {
            siteData[0].statisticTypes.map((item, index) => {
                columns.push({
                    title: item.againstTypeName,
                    children: [{
                        title: '方案违背数量',
                        dataIndex: `${item.againstTypeId}_count`,
                        key: `${item.againstTypeId}_count`,
                        width: isFixed && 90
                    }, {
                        title: '占比',
                        dataIndex: `${item.againstTypeId}_per`,
                        key: `${item.againstTypeId}_per`,
                        width: isFixed && 85
                    }]
                });
            });
        }
        return columns;
    }

    getSecondColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 85,
        render: this.renderTotal
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        render: this.renderCommon
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        render: this.renderCommon
    }, {
        title: '方案违背数量',
        dataIndex: 'count',
        key: 'count',
    }, {
        title: '占比',
        dataIndex: 'present',
        key: 'present',
    }]

    getDataSource = () => {
        const { tableData } = this.state;
        const dataSource = [{
            index: '方案违背数量'
        }, {
            index: '占比'
        }];

        tableData.map((item, index) => {
            if (item.againstTypeName == '合计') {
                dataSource[0][`${item.againstTypeName}_${index}`] = <strong>{item.count}</strong>;
                dataSource[1][`${item.againstTypeName}_${index}`] = <strong>{(item.present * 100).toFixed(2) + '%'}</strong>;
            } else {
                dataSource[0][`${item.againstTypeName}_${index}`] = item.count;
                dataSource[1][`${item.againstTypeName}_${index}`] = (item.present * 100).toFixed(2) + '%';
            }
        })
        return dataSource;
    }

    getSiteDataSource = () => {
        const { siteData } = this.state;
        const dataSource = [];
        siteData.map((item, index) => {
            const params = {};
            if (item.statisticTypes && item.statisticTypes.length > 0) {
                item.statisticTypes.map((innerItem, innerIndex) => {
                    if (item.investigationName == '合计') {
                        params[`${innerItem.againstTypeId}_count`] = <strong>{innerItem.count}</strong>;
                        params[`${innerItem.againstTypeId}_per`] = <strong>{(innerItem.present * 100).toFixed(2) + '%'}</strong>;
                    } else {
                        params[`${innerItem.againstTypeId}_count`] = innerItem.count;
                        params[`${innerItem.againstTypeId}_per`] = (innerItem.present * 100).toFixed(2) + '%';
                    }
                });
            }
            dataSource.push({
                index: item.investigationName == '合计' ? <strong>合计</strong> : (index + 1),
                investigationSiteCode: item.investigationSiteCode,
                investigationSiteName: item.investigationSiteName,
                ...params,
            });
        });
        return dataSource;
    }
    
    getSecondDataSource = () => {
        const { tableData } = this.state;
        const dataSource = [];
        tableData.map((item, index) => {
            dataSource.push({
                index: item.investigationName == '合计' ? <strong>合计</strong> : (index + 1),
                investigationSiteCode: item.investigationSiteCode,
                investigationSiteName: item.investigationSiteName,
                count: item.investigationName == '合计' ? <strong>{item.statisticTypes[0].count}</strong>: item.statisticTypes[0].count,
                present: item.investigationName == '合计' ? <strong>{(item.statisticTypes[0].present * 100).toFixed(2) + '%'}</strong> : (item.statisticTypes[0].present * 100).toFixed(2) + '%',
            });
        });
        return dataSource;
    }

    getContent = () => {
        const { tableData, siteData = [], params, activeKey } = this.state;
        const { type, statisticType } = params;
        let width;
        if (activeKey == '0') {
            if (type == 'patient') {
                if (statisticType == 'FirstStage') {
                    width = tableData.length * 105 + 90;
                } else if (statisticType == 'SecondStage' || statisticType == 'LastStage') {
                    width = tableData.length * 140 + 90;
                }
            } else {
                width = tableData.length * 105 + 90;
            }
        } else {
            if (type == 'patient') {
                if (statisticType == 'FirstStage') {
                    if (siteData.length > 0 && siteData[0].statisticTypes) {
                        width = siteData[0].statisticTypes.length * 175 + 325;
                    }
                } else if (statisticType == 'SecondStage' || statisticType == 'LastStage') {
                    if (siteData.length > 0 && siteData[0].statisticTypes) {
                        width = siteData[0].statisticTypes.length * 175 + 355;
                    }
                }
            } else {
                if (siteData.length > 0 && siteData[0].statisticTypes) {
                    width = siteData[0].statisticTypes.length * 175 + 325;
                }
            }
        }
        return (
            <Table
                columns={activeKey == '0' ? this.getColumns() : this.getSiteColumns()}
                dataSource={activeKey == '0' ? this.getDataSource() : this.getSiteDataSource()}
                rowKey={record => record.key}
                scroll={{ x: width }}
                pagination={false}
                bordered
            />
        )
    }

    getPieChartConfig = () => {
        const { data, subtitle = '' } = this.state;
        const chartsData = [];
        if (subtitle == '') {
            const list = [...data];
            list.length > 0 && list.pop();
            list.map(item => {
                let name = item.againstTypeName;
                if (item.againstTypeName.length > 20) {
                    name = item.againstTypeName.slice(0, 20) + '···'
                }
                chartsData.push({
                    name,
                    allName: item.againstTypeName,
                    id: item.againstTypeId,
                    y: item.present,
                    count: item.count,
                    drilldown: true
                });
            });
        } else {
            data.map(item => {
                chartsData.push({
                    name: item.investigationSiteName,
                    allName: item.investigationSiteName,
                    y: item.statisticTypes[0].present,
                    count: item.statisticTypes[0].count,
                });
            });
        }
        
        const _this = this;
        return {
            chart: {
                type: 'pie',
                events: {
                    drilldown: function (e) {
                        _this.loadSecondData({againstTypeId: e.point.id, againstTypeName: e.point.allName});
                    }
                }
            },
            title: {
                text: ''
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            tooltip: {
                headerFormat: '',
                pointFormat: '{point.allName}: <b>{point.count}</b>, <b>{point.percentage:.2f}%</b>'
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                    },
                    showInLegend: true,
                },
            },
            series: [{
				colorByPoint: true,
				data: chartsData
            }],
            credits: {
                enabled: false
            }
        };
    }

    getChartConfig = () => {
        const { data } = this.state;
        const categories = [],
            series = [{
                name: '本中心方案违背数量',
                data: [],
            }, {
                name: '所有中心方案违背数量',
                data: [],
            }];
        data.map((item, index) => {
            if ((index < data.length - 1) && index < 20) {
                categories.push(item.againstTypeName);
                series[0].data.push(item.siteCount);
                series[1].data.push(item.allCount);
            }
        });
        return {
            chart: {
                type: 'column',
            },
            title: {
                text: ''
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 40,
                layout: 'vertical',
            },
            xAxis: {
                categories,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: '方案违背数量'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    borderWidth: 0
                }
            },
            series,
            credits: {
                enabled: false
            }
        };
    }

    getDetailColumns = () => {
        const { data = [], params } = this.state;
        const { type, statisticType } = params;
        let width;
        if (type == 'patient') {
            if (statisticType == 'FirstStage') {
                width = 105;
            } else if (statisticType == 'SecondStage' || statisticType == 'LastStage') {
                width = 140;
            }
        }

        const columns = [{
            title: '方案违背分类',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 90
        }];

        data.map((item, index) => {
            columns.push({
                title: item.againstTypeName,
                dataIndex: `${item.againstTypeName}_${index}`,
                key: `${item.againstTypeName}_${index}`,
                width,
            })
        });
        return columns;
    }

    getDetailDataSource = () => {
        const { data } = this.state;
        const dataSource = [{
            index: '本中心方案违背数量'
        }, {
            index: '本中心占比'
        }, {
            index: '所有中心方案违背数量'
        }, {
            index: '本中心 VS 所有中心'
        }];

        data.map((item, index) => {
            if (item.againstTypeName == '合计') {
                dataSource[0][`${item.againstTypeName}_${index}`] = <strong>{item.siteCount}</strong>;
                dataSource[1][`${item.againstTypeName}_${index}`] = <strong>{(item.sitePresent * 100).toFixed(2) + '%'}</strong>;
                dataSource[2][`${item.againstTypeName}_${index}`] = <strong>{item.allCount}</strong>;
                dataSource[3][`${item.againstTypeName}_${index}`] = <strong>{(item.siteVsAllPersent * 100).toFixed(2) + '%'}</strong>;
            } else {
                dataSource[0][`${item.againstTypeName}_${index}`] = item.siteCount;
                dataSource[1][`${item.againstTypeName}_${index}`] = (item.sitePresent * 100).toFixed(2) + '%';
                dataSource[2][`${item.againstTypeName}_${index}`] = item.allCount;
                dataSource[3][`${item.againstTypeName}_${index}`] = (item.siteVsAllPersent * 100).toFixed(2) + '%';
            }
        })
        return dataSource;
    }

    getTable = () => {
        const { loading, data, params } = this.state;
        const { type, statisticType } = params;
        let width;
        if (type == 'patient') {
            if (statisticType == 'FirstStage') {
                width = data.length * 105 + 90;
            } else if (statisticType == 'SecondStage' || statisticType == 'LastStage') {
                width = data.length * 140 + 90;
            }
        } else {
            width = data.length * 105 + 90;
        }
        return (
            <div style={{paddingTop: 24}}>
                <Table
                    columns={this.getDetailColumns()}
                    dataSource={this.getDetailDataSource()}
                    rowKey={record => record.key}
                    scroll={{ x: width }}
                    loading={loading}
                    pagination={false}
                    bordered
                />
            </div>
        )
    }

    getSecondTable = () => {
        const { loading } = this.state;
        return (
            <div style={{paddingTop: 24}}>
                <Table
                    columns={this.getSecondColumns()}
                    dataSource={this.getSecondDataSource()}
                    rowKey={record => record.key}
                    loading={loading}
                    pagination={false}
                    bordered
                />
            </div>
        )
    }

    componentDidMount() {
        const isSite = sessionStorage.investigationSiteName == '中心汇总';
        const panes = [{
            title: '汇总',
            key: '0',
            closable: false
        }, {
            title: '中心明细',
            key: '1',
            closable: false
        }];
        this.setState({
            panes,
            isSite,
            activeKey: '0',
        }, () => {
            this.loadData();
        });
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG',
        ];
    }

    render() {
        const { params, panes, activeKey, isSite, subtitle = '', loading } = this.state;
        const { type, statisticType } = params;
        const config = isSite ? this.getPieChartConfig() : this.getChartConfig();
        return (
            <div className="content primary-tabs-active">
                <SideNav selectKey='/summary/violation' />
                <div className="main">
                    <div className="T-tit">
                        <div className="txt">
                            <h3 style={{ marginBottom: 10 }}>方案违背分类统计{subtitle != '' && <span style={{fontSize: 13}}>-{subtitle}</span>}</h3>
                        </div>
                    </div>
                    {
                        subtitle == ''
                        ?
                            <div style={{marginBottom: 10}}>
                                <Select 
                                    style={{width: 180, marginRight: 20}}
                                    onChange={value => this.handleSelectChange(value, 'type')}
                                    value={type}
                                >
                                    <Option value="patient">与患者有关的方案违背分类</Option>
                                    <Option value="non_patient">与患者无关的方案违背分类</Option>
                                </Select >
                                {
                                    type == 'patient' &&
                                    <Select 
                                        style={{width: 80}}
                                        onChange={value => this.handleSelectChange(value, 'statisticType')}
                                        value={statisticType}
                                    >
                                        <Option value="FirstStage">一级分类</Option>
                                        <Option value="SecondStage">二级分类</Option>
                                        <Option value="LastStage">末级分类</Option>
                                    </Select >
                                }
                            </div>
                        :
                            <div style={{marginBottom: 10}}>
                                <div onClick={this.loadData} style={{float: 'right', marginRight: 22, color: '#5750c9b3', cursor: 'pointer'}}><i className="icon iconfont">&#xe63d;</i> 返回上一层</div>
                            </div>
                    }
                    {
                        statisticType != 'LastStage' &&
                        <div className="charts" style={{ marginBottom: 10 }}>
                            <Highcharts config={{ ...config, ...chartsConfig }} />
                        </div>
                    }
                    <div style={statisticType == 'LastStage' ? {position: 'relative', marginTop: 30} : {position: 'relative'}}>
                        <Icon type="download" onClick={this.export} style={{position: 'absolute', right: 10, color: '#51aaec', cursor: 'pointer', zIndex: 1}} />
                        {
                            isSite
                            ?
                                subtitle == ''
                                ?
                                    <Spin spinning={loading}>
                                        {
                                            <Tabs
                                                onChange={this.onChange}
                                                activeKey={activeKey}
                                                type="card"
                                            >
                                                {panes.map(pane => <TabPane animated={false} tab={pane.title} key={pane.key} closable={pane.closable}>{pane.content}</TabPane>)}
                                            </Tabs>
                                        }
                                    </Spin>
                                :
                                    this.getSecondTable()
                            :
                            this.getTable()
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ChartsViolation;



// WEBPACK FOOTER //
// ./src/components/summary/Violation.js